import styled from "styled-components";

const InputWithIcon = styled.input.attrs((props) => ({
    type: props.type || "text",
  }))`
    background: #000D30;
    background-image: url(${(props) => props.src});
    background-repeat: no-repeat;
    text-indent: 40px;
    border: 0.5px solid #ffffff90;
    border-radius: 12px;
    width: 100%;
    padding: 20px;
    font-family: 'Spartan';
    background-position: 20px 15px;
    ::placeholder {
      color: white;
    }
    color: white;
  `;
export default InputWithIcon;